import gql from 'graphql-tag';

export const AllLocations = gql`
  query activeLocations($staff: Boolean) {
    activeLocations(staff: $staff) {
      id
      name_en
      name_ar
      type
      is_active
      city {
        id
        name_en
        name_ar
        is_active
      }
    }
  }
`;
